import { render, staticRenderFns } from "./CountryProfilesMobile.vue?vue&type=template&id=612f2d7e&"
import script from "./CountryProfilesMobile.vue?vue&type=script&lang=js&"
export * from "./CountryProfilesMobile.vue?vue&type=script&lang=js&"
import style0 from "./CountryProfilesMobile.vue?vue&type=style&index=0&id=612f2d7e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports